/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBlendMode = createReactComponent("outline", "blend-mode", "IconBlendMode", [["path", { "d": "M14.5 9.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0", "key": "svg-0" }], ["path", { "d": "M9.5 14.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0", "key": "svg-1" }]]);

export { IconBlendMode as default };
//# sourceMappingURL=IconBlendMode.mjs.map
